<template>
  <div>
    <h3>参加登録</h3>
    <hr>

    <div id="modal-content" v-if="modalState">
      <Modal @close="closeModal">
        <Validation :formData="formData" @submit="sendInfo" @close="closeModal"/>
      </Modal>
    </div>

    <div id="register">
    <p>参加登録をするには、次のフォームに必要事項をご記入ください。</p>
    <form @submit.prevent="registeration">
      <div class="form-group">
        <div class="control">
          <label for="myname">氏名<span class="required">必須</span></label>
          <input id="myname" type="text" v-model="myname" class="form-control" placeholder="例）南部陽一郎" required>
        </div>

        <div class="control">
          <label for="belong">所属<span class="required">必須</span></label>
          <input id="belong" type="text" v-model="belong" class="form-control" placeholder="例）大阪市立大学数学研究所" required>
        </div>

        <div class="control">
          <label for="position">身分<span class="required">必須</span></label>
          <input id="position" type="text" v-model="position" class="form-control" placeholder="例）M2, D1, Ph.D, etc." required>
        </div>

        <div class="control">
          <label for="mymail">メールアドレス<span class="required">必須</span></label>
          <input id="mymail" type="email" v-model="mymail" class="form-control" placeholder="例）test@example.com" required>
        </div>

        <div class="control">
          <label>ワークショップ参加予定（複数回答可）<span class="required">必須</span></label>
          <div class="checkbox">
            <label class="checkbox-inline"><input type="checkbox" v-model="participation" value="1">&nbsp;1日目</label>
            <label class="checkbox-inline"><input type="checkbox" v-model="participation" value="2">&nbsp;2日目</label>
            <label class="checkbox-inline"><input type="checkbox" v-model="participation" value="3">&nbsp;3日目</label>
          </div>
        </div>

        <!-- 講演者決定のため不要 -->
        <!-- <div class="control">
          <label>講演希望</label>
          <div class="checkbox">
            <label class="checkbox-inline"><input type="checkbox" v-model="talk.do">&nbsp;希望します</label>
          </div>
          <label style="margin-left:20px;">講演タイトル<input id="talk-title" v-model="talk.title" class="form-control" placeholder="例）時空の隠れた対称性"
            disabled=ture /></label>
        </div> -->

        <div class="control">
          <label>懇親会参加予定</label>
          <div class="checkbox">
            <label class="checkbox-inline"><input type="checkbox" v-model="banquet">&nbsp;参加します</label>
          </div>
        </div>

        <div class="control">
          <label for="message">ご意見等</label>
          <textarea id="message" v-model="message" rows="3" class="form-control" />
        </div>

        <button type="submit" id="btn_register">登録する</button>

      </div>
    </form>
    <p>※参加登録無しでも、当日飛び入りで研究会にご参加いただけます。</p>
    </div>

  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import { db } from '../main'
// import { fbFunctions } from '../main'
import Modal from './Modal'
import Validation from './Validation'

export default {
  name: 'Register',
  components: {
    Modal,
    Validation
  },
  data () {
    return {
      modalState: false,
      formData: {},
      myname: '',
      belong: '',
      position: '',
      mymail: '',
      // talk: {
      //   do: false,
      //   title: ''
      // },
      banquet: false,
      participation: [],
      message: ''
    }
  },
  // updated () {
  //   document.getElementById('talk-title').disabled = !(this.talk.do)
  //   document.getElementById('talk-title').required = this.talk.do
  // },
  methods: {
    registeration () {
      if (this.participation.length === 0) {
        alert('参加予定をチェックしてください')
        return
      }
      var btn = document.getElementById('btn_register')
      btn.disabled = true
      const messageArr = this.message.replace(/\r?\n/g, '\n').split(/\n/)
      const datetime = firebase.firestore.FieldValue.serverTimestamp()
      this.formData = {
        name: this.myname,
        belong: this.belong,
        position: this.position,
        email: this.mymail,
        // talk: this.talk,
        banquet: this.banquet,
        participation: this.participation.sort(),
        message: messageArr,
        datetime: datetime
      }

      this.modalState = true

      btn.disabled = false
    },
    sendInfo () {
      db.collection('participants').add(this.formData)
      // this.sendMail()
      this.$router.push('/Participants')
    },
    closeModal () {
      this.modalState = false
    }
    // sendMail: function () {
    //   console.log('send email')
    //   const mailer = fbFunctions.httpsCallable('sendMail')
    //   mailer(this.formData)
    // }
  }
}
</script>

<style>

#register {
  background-color: #fafafa;
  background-color:#fff;
  margin: 10px auto;
  border: 1px solid #fff;
  padding: 30px;
}
.control{
  margin-bottom: 1em;
}
.control input {
  border-bottom: 1px solid #d1d1d1;
  font-size: 1,2em;
  width: 100%;
  padding: 8px;
}
.checkbox input {
  margin-left: 30px;
  width: 30px;
  padding: 8px;
}
.required {
  background-color: #fee;
  border-radius: 3px;
  color: #f33;
  font-size: .9em;
  font-weight: bold;
  margin-left: .3em;
  padding: 3px;
}
#btn_register {
  background-color: rgb(34, 110, 147);
  border-radius: 5px;
  box-shadow: 0 0 8px rgba(0,0,0, .4);
  color: #fff;
  padding: 15px;
  text-align: center;
  width: 100%;
}
label {
  display: block;
  margin-bottom: .5em;
}

#modal-content {
  z-index: 2;
  position: fixed;
}

</style>



// WEBPACK FOOTER //
// src/components/Register.vue